import * as React from 'react'
import Link from 'gatsby-link'
import { Element } from 'react-scroll'
import * as classnames from 'classnames'

import Container from '../Container'
import Row from '../Row'
import Col from '../Col'
import FullScreenSection from '../FullScreenSection'
import UnsplashCreditBadge from '../UnsplashCreditBadge'

import * as styles from './Features.module.scss'

const Features = () => (
  <FullScreenSection name="features">
    <Container>
      <Row reverse={true} style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
        <Col>
          <div className={styles.featureBox}>
            <h2>Conference Management App</h2>
            <p>
              A custom conference management web application with various useful features for conference organisers.
            </p>
            <p>
            <ul>
              <li>Python / Django based backend</li>
              <li>Wagtail CMS included, run headless or with (optional) included templates</li>
              <li>Direct integration with Stripe for payments, Guidebook for custom mobile experience, email systems and more</li>
              <li>Flexible data export functionality to common formats or via REST API</li>
            </ul>
            </p>
          </div>
        </Col>
        <Col>
          <div className={styles.featureImageBox}>
            <img src={require('./conference-app.jpg')} />
            <div className={styles.credit}>
              <UnsplashCreditBadge
                src=""
              >
                Dashboard
              </UnsplashCreditBadge>
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
        <Col>
          <div className={classnames(styles.featureBox, styles.guessWhat)}>
            <h2>Purview</h2>
            <p>
              Together with <a href="https://github.com/dflemstr">@dflemstr</a> I worked on Purview<sup>1</sup>, a desktop application to detect digital forgery in photographic images.
            </p>
            <ul>
              <li>Written in Scala and Java</li>
              <li>Awarded <em>4th place</em> in Jugend Forscht 2010</li>
            </ul>
            <p>
              <small>
                <sup>[1]</sup> <a href="https://github.com/mroth23/purview">https://github.com/mroth23/purview</a>
              </small>
            </p>
          </div>
        </Col>
        <Col>
          <div className={styles.featureImageBox}>
            <img src={require('./rucksack-magazine-386319.jpg')} />
            <div className={styles.credit}>
              <UnsplashCreditBadge
                src="https://unsplash.com/@rucksackmag?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge"
              >
                Rucksack Magazine
              </UnsplashCreditBadge>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </FullScreenSection>
)

export default Features



// WEBPACK FOOTER //
// ./src/components/Features/Features.tsx